<template>
  <div>

  <Package/>
    <!-- ก้าวต่อไปของกยท. -->
   <Blog/>
<!-- วิดีโอ -->
  <FAQ/>
   <Testimonial/>
     <Screenshots/>
  <Team/>
 <!--     <Subscribe/> -->


 
  
     <!--  <Footer/> -->
      <!-- end footer section -->
     
      <Copyright/>

  </div>
</template>
<script>
import slider from '../components/slider.vue'

export default {
  components: { slider },
  name: 'Index',
  mounted: function () {
    document.body.classList.remove('inner-page')
  }
}
</script>
